import React, { useState } from "react";
import { Box, Typography, Button, TextField, Grid } from "@mui/material";
import { functions, httpsCallable } from "../firebase";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    howDidYouHear: "",
    projectDescription: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState(""); // State for email validation error

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Updating ${name} to: ${value}`);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // email validation
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setEmailError("Please enter a valid email address (e.g., example@domain.com)");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form data before submit:", formData);
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const sendContactEmail = httpsCallable(functions, "sendContactEmail");
      console.log("Sending to Cloud Function:", formData);
      const result = await sendContactEmail({ ...formData });
      console.log("Cloud Function response:", result.data);
      setSuccessMessage(result.data.message);
      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
        howDidYouHear: "",
        projectDescription: "",
      });
      setEmailError(""); // Clear email error on success
    } catch (error) {
      setErrorMessage("Failed to send your message. Please try again.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Validate form
  const isEmailValid = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.email);
  };

  const isFormValid =
    formData.name.trim() !== "" &&
    formData.company.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.phone.trim() !== "" &&
    formData.howDidYouHear.trim() !== "" &&
    formData.projectDescription.trim() !== "" &&
    isEmailValid();

  return (
    <Box sx={{ textAlign: "center", padding: "20px", mt: 3 }}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        Contact Us
      </Typography>

      <Typography>
        Interested in partnering with
        <span style={{ fontWeight: "bold" }}> Banner Day Threads?</span>
      </Typography>
      <Typography>
        Please fill out the form and one of our team members will be in contact
        soon!
      </Typography>

      {successMessage && (
        <Typography sx={{ color: "green", mt: 2 }}>
          {successMessage}
        </Typography>
      )}
      {errorMessage && (
        <Typography sx={{ color: "red", mt: 2 }}>
          {errorMessage}
        </Typography>
      )}

      <Box sx={{ maxWidth: 800, margin: "0 auto", mt: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Your Name"
                variant="outlined"
                name="name"
                value={formData.name}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Company/Organization"
                variant="outlined"
                name="company"
                value={formData.company}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
                error={!!emailError} // Show error if emailError exists
                helperText={emailError} // Display email validation error message
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number"
                variant="outlined"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="How did you hear about us?"
                variant="outlined"
                name="howDidYouHear"
                value={formData.howDidYouHear}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tell us about your project..."
                variant="outlined"
                multiline
                rows={4}
                name="projectDescription"
                value={formData.projectDescription}
                onChange={handleChange}
                sx={{ backgroundColor: "#F6F6F6" }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Typography alignSelf="center">
                36-piece minimum with a 6-7 week turnaround from art approval to
                delivery.
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF8300",
                  width: { xs: "40%", sm: "40%", md: "30%" },
                  borderRadius: 0,
                }}
                type="submit"
                disabled={loading || !isFormValid}
              >
                {loading ? "Sending..." : "Send"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default ContactUsPage;